import React from 'react';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
import { aboutCourse } from '../data/mock';

const AboutCourse = () => {
  const problemas = [
    "Tem receio de mexer na mesa durante o culto ou evento",
    "Sente que o som fica embolado e difícil de corrigir",
    "Não consegue montar uma boa estrutura de mixagem",
    "Tem dificuldade em fazer ROTEAMENTO",
    "Não entende claramente o signal flow da WING"
  ];

  return (
    <section id="sobre" className="pt-2 pb-12 md:pt-6 md:pb-20 bg-black relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-green-500/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-3 sm:px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Logo Dominando a WING */}
          <div className="flex justify-center mb-2 sm:mb-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_4f5cf654-3a0c-4d01-a704-3b564425efff/artifacts/q91ynqi5_Logo%20do%20Programa%20Mentoria%20dOMINDO%20A%20wing.png"
              alt="Dominando a WING - Programa de Mentoria"
              className="h-20 sm:h-28 md:h-40 lg:h-48 w-auto"
            />
          </div>

          {/* Title */}
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-3 sm:mb-6 px-2 leading-tight">
              Mentoria em Grupo de{' '}
              <span className="highlight-marker-solid whitespace-nowrap">Alto Impacto</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto px-2 leading-relaxed">
              4 aulas ao vivo para tirar todas as suas dúvidas + mais de 20 aulas gravadas na plataforma exclusiva.
              As aulas são gravadas e ficam disponíveis na plataforma exclusiva para alunos durante 1 ano.
            </p>
          </div>

          {/* Para Quem É Section */}
          <div className="mb-8 sm:mb-12">
            <div className="text-center mb-6 sm:mb-10">
              <span className="inline-block px-3 py-1.5 sm:px-4 sm:py-2 bg-yellow-500/20 text-yellow-400 rounded-full text-xs sm:text-sm font-semibold mb-3 sm:mb-4">
                PÚBLICO-ALVO
              </span>
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-2">
                Para quem é essa mentoria?
              </h3>
              <p className="text-lg sm:text-xl text-yellow-400 font-medium">Se você:</p>
            </div>

            <div className="max-w-3xl mx-auto">
              <div className="space-y-2 sm:space-y-4">
                {problemas.map((problema, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 md:p-5 glass rounded-lg sm:rounded-xl border border-yellow-500/20 hover:border-yellow-500/40 transition-all duration-300"
                  >
                    <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-yellow-500/20 rounded-full flex items-center justify-center">
                      <AlertCircle className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400" />
                    </div>
                    <p className="text-white text-sm sm:text-base md:text-lg">{problema}</p>
                  </div>
                ))}
              </div>

              {/* Solução */}
              <div className="mt-6 sm:mt-8 p-4 sm:p-6 glass-dark rounded-xl sm:rounded-2xl border border-green-500/30 text-center">
                <div className="flex items-center justify-center gap-2 mb-2 sm:mb-3">
                  <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-green-400" />
                  <span className="text-green-400 font-bold text-base sm:text-lg">Essa mentoria é para você!</span>
                </div>
                <p className="text-gray-300 text-sm sm:text-base">
                  Vamos resolver cada um desses problemas juntos, de forma prática e didática.
                </p>
              </div>
            </div>
          </div>

          {/* Bottom CTA */}
          <div className="text-center">
            <div className="inline-block glass-dark p-4 sm:p-6 md:p-8 rounded-xl sm:rounded-2xl border border-green-500/30">
              <p className="text-gray-300 mb-3 sm:mb-4 text-sm sm:text-base">
                <span className="text-yellow-400 font-bold text-lg sm:text-xl">Início: em breve</span> • Vagas limitadas
              </p>
              <a
                href="#inscricao"
                className="inline-block bg-green-500 hover:bg-green-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold text-sm sm:text-base transition-all duration-300 hover:scale-105 glow-green"
              >
                GARANTIR MINHA VAGA
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCourse;
